/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PoseCompareResponse {
    _2d_vid_address?: string;
    Elbow_L_Score?: number;
    Elbow_R_Score?: number;
    Input_Elbow_L_Angles?: Array<number>;
    Input_Elbow_R_Angles?: Array<number>;
    Input_Knee_L_Angles?: Array<number>;
    Input_Knee_R_Angles?: Array<number>;
    Input_Shoulder_L_Angles?: Array<number>;
    Input_Shoulder_R_Angles?: Array<number>;
    Input_Torso_Angles?: Array<number>;
    Knee_L_Score?: number;
    Knee_R_Score?: number;
    Shoulder_L_Score?: number;
    Shoulder_R_Score?: number;
    Similarity?: number;
    Source_Elbow_L_Angles?: Array<number>;
    Source_Elbow_R_Angles?: Array<number>;
    Source_Knee_L_Angles?: Array<number>;
    Source_Knee_R_Angles?: Array<number>;
    Source_Shoulder_L_Angles?: Array<number>;
    Source_Shoulder_R_Angles?: Array<number>;
    Source_Torso_Angles?: Array<number>;
    Torso_Score?: number;
    frame_number?: number;
    notPaid?: boolean;
    result?: string;
    source_angels?: string;
    taget_angels?: string;
}

